"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundEpic = void 0;
var _service = require("./service");
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _types = require("./types");
var _types2 = require("../config/types");
var _types3 = require("../game/types");
var _types4 = require("../loader/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SoundEpic = exports.SoundEpic = /*#__PURE__*/function () {
  function SoundEpic() {
    var _this = this;
    _classCallCheck(this, SoundEpic);
    _defineProperty(this, "soundService", void 0);
    _defineProperty(this, "muteOnError", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types3.GAME_STATUS_SET), (0, _operators.filter)(function (a) {
        return _types3.UNRECOVERABLE_STATES.indexOf(a.payload) != -1;
      }), (0, _operators.mergeMap)(function () {
        _this.soundService.Mute();
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "debugSoundsToggle", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_TOGGLE_DEBUG), (0, _operators.mergeMap)(function () {
        _this.soundService.debugSounds = store.value.sound.debug;
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "loadingCompleted", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types4.LOADING_COMPLETED), (0, _operators.filter)(function () {
        return _types3.UNRECOVERABLE_STATES.indexOf(store.value.game.gameStatus) == -1;
      }), (0, _operators.filter)(function () {
        return store.value.config.sound;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.UnMute();
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "createSound", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_CREATE), (0, _operators.mergeMap)(function (a) {
        _this.soundService.CreateSound(a.payload.sounds, a.payload.files, a.payload.volume, a.payload.autoplay, a.payload.loop);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "createSoundSprite", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_CREATE_SPRITE), (0, _operators.mergeMap)(function (a) {
        _this.soundService.CreateSoundFromSprite(a.payload.sound, a.payload.sprite, a.payload.files, a.payload.volume, a.payload.autoplay, a.payload.loop);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "play", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_PLAY), (0, _operators.mergeMap)(function (a) {
        _this.soundService.Play(a.payload.sound, a.payload.onlyOnce, a.payload.spriteId, a.payload.volume, a.payload.stereo, a.payload.force, a.payload.delay);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "stopSound", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_STOP), (0, _operators.filter)(function (a) {
        return a.payload;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.StopSound(a.payload.sound, a.payload.fadeTime, a.payload.spriteId);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onFade", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_FADE), (0, _operators.filter)(function (a) {
        return a.payload;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.Fade(a.payload.sound, a.payload.spriteId, a.payload.from, a.payload.to, a.payload.duration);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onRaise", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_RAISE), (0, _operators.filter)(function (a) {
        return a.payload;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.Raise(a.payload.sound, a.payload.spriteId, a.payload.to, a.payload.duration);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onRate", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_PLAY_RATE), (0, _operators.filter)(function (a) {
        return a.payload;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.Rate(a.payload.sound, a.payload.spriteId, a.payload.rate);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onLoop", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_LOOP), (0, _operators.filter)(function (a) {
        return a.payload;
      }), (0, _operators.mergeMap)(function (a) {
        _this.soundService.Loop(a.payload.sound, a.payload.spriteId, a.payload.loop, a.payload.actionOnEnd);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "toggleGlobalSound", function (action$, store) {
      return action$.pipe(
      /// we check this on SERVER_CONFIG which actually is cookie reead as well. This should solve the soiund despoite mute cookie
      (0, _reduxObservable.ofType)(_types2.SOUND_TOGGLE, _types2.SERVER_CONFIG), (0, _operators.mergeMap)(function () {
        if (store.value.config.sound) {
          _this.soundService.UnMute();
        } else {
          _this.soundService.Mute();
        }
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "toggleMusic", function (action$, store) {
      return action$.pipe(
      /// we check this on SERVER_CONFIG which actually is cookie reead as well. This should solve the soiund despoite mute cookie
      (0, _reduxObservable.ofType)(_types2.MUSIC_TOGGLE, _types2.SERVER_CONFIG), (0, _operators.mergeMap)(function () {
        if (store.value.config.music) {
          _this.soundService.UnMuteGroup(_types.SoundPack.Music);
        } else {
          _this.soundService.MuteGroup(_types.SoundPack.Music);
        }
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onBlur", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types2.WINDOW_BLUR), (0, _operators.mergeMap)(function () {
        _this.soundService.Mute();
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "onFocus", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types2.WINDOW_FOCUS), (0, _operators.filter)(function () {
        return store.value.config.sound;
      }), (0, _operators.filter)(function () {
        return _types3.UNRECOVERABLE_STATES.indexOf(store.value.game.gameStatus) == -1;
      }), (0, _operators.mergeMap)(function () {
        _this.soundService.UnMute();
        return _rxjs.EMPTY;
      }));
    });
    this.soundService = new _service.SoundService();
  }
  return _createClass(SoundEpic, [{
    key: "getEpic",
    value: function getEpic() {
      return (0, _reduxObservable.combineEpics)(this.muteOnError, this.createSound, this.play, this.stopSound, this.toggleGlobalSound, this.onBlur, this.onFocus, this.onFade, this.loadingCompleted, this.createSoundSprite, this.onRate, this.onLoop, this.debugSoundsToggle, this.onRaise, this.toggleMusic);
    }
  }]);
}();
//# sourceMappingURL=epics.js.map